import { useState } from 'react';

export const useDashboardModal = () => {
  const [showDashboardModal, setShowDashboardModal] = useState(false);

  const openModal = () => setShowDashboardModal(true);
  const closeModal = () => setShowDashboardModal(false);

  return {
    showDashboardModal,
    openModal,
    closeModal
  };
};
